/**
 * Layout y clases de transición del mazo apilado en `NotificationItem`.
 * Detalle UX: comentario de bloque del componente.
 */

/** Vista previa colapsada: máximo de tarjetas visibles (incluye la frontal). */
export const STACK_PREVIEW_MAX_VISIBLE = 3;

/** Desfase vertical base por capa (`bottom` negativo) en stack colapsado. */
export const STACK_OFFSET_PX = 8;

/** Recorte horizontal por nivel de profundidad sin hover (inset simétrico). */
export const STACK_LAYER_COLLAPSED_TRIM_PER_LEVEL_PX = 22;

/** Desfase vertical por capa con hover (stack más abierto). */
export const STACK_OFFSET_EXPANDED_PX = 44;

/** Gap entre filas en la vista lista completa. */
export const FULL_LIST_GAP_PX = 8;

/** Duración y easing compartidos (stack, lista, chrome). */
export const STACK_MOTION_TIMING =
  'ui-duration-500 ui-ease-in-out motion-reduce:ui-transition-none';

/** Alias de timing para expansión del stack (misma cadena que `STACK_MOTION_TIMING`). */
export const STACK_EXPAND_EASE = STACK_MOTION_TIMING;

/** Transición del pie y envoltorio de barra (opacity + max-height). */
export const STACK_CHROME_TRANSITION = `ui-transition-[opacity,max-height] ${STACK_MOTION_TIMING}`;

/** Ventana sin transición de padding tras mutar la cola (ms). */
export const STACK_LAYOUT_SETTLE_MS = 560;
